// extracted by mini-css-extract-plugin
module.exports = {"content":"tab-all-activities_content__2a4cx"};